module.exports = __webpack_public_path__ + "img/d_1.ed46e3dc.png";